import {LiveForm, Nette} from 'live-form-validation';

window.Nette = Nette;
window.LiveForm = LiveForm;
Nette.initOnLoad();
